var map = {
	"./box.svg": 34497,
	"./close.svg": 77124,
	"./empty-nomsg.svg": 31324,
	"./empty-norecord.svg": 26454,
	"./empty.svg": 73801,
	"./upload.svg": 85273,
	"./wszy-logo-slogan.svg": 35962,
	"./wszy-logo.svg": 91053,
	"./wszy-slogan.svg": 72616,
	"./zljm-logo.svg": 84029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66117;